import React, { useState } from 'react';
import { Button, PopUp } from 'geniebook-ui/dist';

// button
const ButtonGroup = ({
  onCreateWorksheet,
  closePopup,
}: {
  onCreateWorksheet: () => void;
  closePopup: () => void;
}) => {
  return (
    <>
      <div className={'w-full'}>
        <Button
          style={{ maxWidth: '100%' }}
          className={'w-full'}
          onClick={() => {
            onCreateWorksheet();
            closePopup();
          }}
        >
          Create worksheet
        </Button>
      </div>
      <div className={'w-full -mb-4'}>
        <Button
          style={{ maxWidth: '100%' }}
          variant="secondary"
          className={'w-full'}
          onClick={() => closePopup()}
        >
          Maybe later
        </Button>
      </div>
    </>
  );
};

export type GenerateWorksheetPopupProps = {
  title: string;
  description: string | React.ReactNode;
  onCreateWorksheet: () => void;
  onClosePopup: () => void;
};

const GenerateWorksheetPopup = ({
  title,
  description,
  onCreateWorksheet,
  onClosePopup,
}: GenerateWorksheetPopupProps) => {
  const [show, setShow] = useState(true);

  const closePopup = () => {
    onClosePopup();
    setShow(false);
  };

  // view
  return (
    show && (
      <PopUp
        title={title}
        buttonGroup={
          <ButtonGroup
            onCreateWorksheet={onCreateWorksheet}
            closePopup={closePopup}
          />
        }
        onClose={() => closePopup()}
        description={description}
        img={`${process.env.GCS_CDN_BUCKET}assets/images/Class2Smart/Create_Worksheet.svg`}
        className="!max-w-[462px]"
        imgFullwidth
      />
    )
  );
};

export default GenerateWorksheetPopup;
